import usePrepDashboardStore from './prepDashboardStore'
import usePrepListStore from './prepListStore'

type MyPrepOrderResponse = {
  ordered_ids?: number[]
  total?: number
}
const normalizeOrderedIds = (ids: readonly number[]): number[] =>
  Array.from(
    new Set(
      ids
        .filter((id) => Number.isFinite(id) && id > 0)
        .map((id) => Math.floor(id)),
    ),
  )

export const markDashboardMyPrepDirty = (): void => {
  usePrepDashboardStore.getState().markMyPrepDirty()
}

export const syncAuthoritativeMyPrepOrder = (
  response: MyPrepOrderResponse | null | undefined,
  fallbackOrder: readonly number[],
): number[] => {
  const orderedIds = normalizeOrderedIds(
    Array.isArray(response?.ordered_ids) ? response.ordered_ids : fallbackOrder,
  )
  const total =
    typeof response?.total === 'number' && Number.isFinite(response.total)
      ? Math.max(0, Math.floor(response.total))
      : orderedIds.length

  usePrepListStore.getState().replaceMyPrepOrder(orderedIds, total)
  usePrepDashboardStore.getState().syncMyPrepOrder(orderedIds)

  return orderedIds
}
